import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-72723e9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"3rem","margin":"0.8rem auto"},
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "submit-btn" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_5 = { class: "overlay-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("加载中...")

import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { Button, Field, CellGroup, Toast, NavBar } from "vant";
import Request, { request } from "@/provide/fetch";
import { getQueryString } from "@/utils";
import { getChannelCodeFromCache } from "@/utils/channelCode";

export default /*#__PURE__*/_defineComponent({
  name: 'login',
  setup(__props) {

const router = useRouter();
const tel = ref("");
const captcha = ref("");
const loading = ref(false);
const smsLoading = ref(false);
const loginVisible = ref(false);
const handleSummit = async () => {
  if (!tel.value) {
    return Toast("请填写手机号");
  }
  if (!/1\d{10}/.test(tel.value)) {
    return Toast("请填写正确的手机号");
  }
  if (!captcha.value) {
    return Toast("请填写验证码");
  }
  loading.value = true;
  const res = await Request({
    url: `/user/login`,
    method: "POST",
    data: {
      phone: tel.value, //电话
      captcha: captcha.value, //验证码
    },
    headers: {
      channelCode: getChannelCodeFromCache()
    }
  }).catch(() => {
    Toast("网络错误，请稍后重试");
  });
  loading.value = false;
  if (res.code === 200) {
    const { token, employees } = res.data;
    localStorage.setItem("token", token);
    localStorage.setItem("userInfo", JSON.stringify(res.data));
    router.go(-1)
  } else {
    Toast(res.message);
  }
};
const getSms = async () => {
  if (!tel.value) {
    return Toast("请填写手机号");
  }
  smsLoading.value = true;
  const resData = await request({
    url: `/user/sendCaptcha?phone=${tel.value}`,
    headers: {
      channelCode: getChannelCodeFromCache()
    }
  }).catch(() => {
    Toast("网络错误-7");
    smsLoading.value = false;
  });
  smsLoading.value = false;
  if (resData.code === 200) {
    countdown();
    Toast("发送成功");
  } else {
    Toast(resData.message);
  }
};
const count = ref(0);
const countdown = () => {
  count.value = 59;
  let timer: number | null = setInterval(() => {
    if (count.value > 0) {
      count.value--;
    } else {
      timer && clearInterval(timer);
      timer = null;
    }
  }, 1000);
};

return (_ctx: any,_cache: any) => {
  const _component_Form = _resolveComponent("Form")!
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(NavBar), { title: "境外上网" }),
      _hoisted_2,
      _createVNode(_component_Form, { style: {"margin":"0 0.5rem"} }, {
        default: _withCtx(() => [
          _createVNode(_unref(Field), {
            class: "FieldLogin",
            placeholder: "请输入手机号码",
            modelValue: tel.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tel).value = $event)),
            type: "tel",
            maxlength: "11",
            label: "手机号"
          }, null, 8, ["modelValue"]),
          _createVNode(_unref(Field), {
            class: "FieldLogin",
            modelValue: captcha.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((captcha).value = $event)),
            center: "",
            clearable: "",
            maxlength: "6",
            label: "验证码",
            placeholder: "请输入验证码"
          }, {
            button: _withCtx(() => [
              (count.value > 0)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    style: _normalizeStyle({ fontSize: '0.28rem', fontWeight: 400, color: '#999' })
                  }, " 重新发送（" + _toDisplayString(count.value) + "s） ", 5))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    style: {"color":"#386bf6"},
                    onClick: getSms
                  }, "发送验证码"))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Button), {
              style: {"border-radius":"12px"},
              loading: loading.value,
              round: "",
              block: "",
              type: "primary",
              onClick: handleSummit
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, !loginVisible.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createVNode(_component_van_loading, {
        color: "#0094ff",
        size: "24px",
        vertical: ""
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, loginVisible.value]
    ])
  ], 64))
}
}

})